// extracted by mini-css-extract-plugin
export default {"container":"VerifyEmail_container__rNd4c","spinner":"VerifyEmail_spinner__KxKba","spin":"VerifyEmail_spin__NNj21"};